import { render, staticRenderFns } from "./OrganizationPeerGroupCreator.vue?vue&type=template&id=29bb5a2c&"
import script from "./OrganizationPeerGroupCreator.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPeerGroupCreator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports